@if (leftBanner) {
  <div class="left-banner">
    @if (leftBanner.link) {
      <a [href]="leftBanner.link" [target]="leftBanner.target">
        <ng-container [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{ $implicit: leftBanner }"></ng-container>
      </a>
    }
    @if (!leftBanner.link) {
      <div>
        <ng-container [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{ $implicit: leftBanner }"></ng-container>
      </div>
    }
  </div>
}
@if (rightBanner) {
  <div class="right-banner">
    @if (rightBanner.link) {
      <a [href]="rightBanner.link" [target]="rightBanner.target">
        <ng-container [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{ $implicit: rightBanner }"></ng-container>
      </a>
    }
    @if (!rightBanner.link) {
      <div>
        <ng-container [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{ $implicit: rightBanner }"></ng-container>
      </div>
    }
  </div>
}
<ng-template #contentTemplate let-banner>
  <img [src]="(isMobile && banner.mobileImage ? banner.mobileImage : banner.image) | cms: 75 : 768" [alt]="banner.title" />
  <div>
    <h2>{{ banner.title }}</h2>
    @if (banner.link) {
      <app-text-button>{{ banner.textboxButton ? banner.textboxButton : 'Se mere' }}</app-text-button>
    }
  </div>
</ng-template>
